var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am2-characters-left-copy"},[(_vm.charactersLeftInTemplate)?_c('ar-text',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:({
      content: _vm.tooltip,
    }),expression:"{\n      content: tooltip,\n    }",modifiers:{"top":true}}],class:[
      'characters-left-copy',
      _vm.noCharactersLeft && 'warning' ],attrs:{"size":"xs","text":_vm.charactersString,"align":"right"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }